import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import {
  msalConfig,
  msalGuardConfig,
  msalInterceptorConfig,
} from './app-config';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppWrapperComponent } from './navigation/app-wrapper/app-wrapper.component';
import { NavbarComponent } from './navigation/navbar/navbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { AvatarComponent } from './common/components/avatar/avatar.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HomeTableComponent } from './sections/home-page/home-table/home-table.component';
import { HomeComponent } from './sections/home-page/home/home.component';
import { ServerErrorInterceptor } from 'src/error-handling/server-error-interceptor';
import { GlobalErrorHandler } from 'src/error-handling/global-error-handler';
import { CreateUserDialogComponent } from './dialogs/create-user-dialog/create-user-dialog.component';
import { EditUserDialogComponent } from './dialogs/edit-user-dialog/edit-user-dialog.component';
import { DeleteUserDialogComponent } from './dialogs/delete-user-dialog/delete-user-dialog.component';
import { ReviewCreateUserDialogComponent } from './dialogs/review-create-user-dialog/review-create-user-dialog.component';
import { DialogContainerComponent } from '../common-panel/components/dialog-container/dialog-container.component';
import { ReviewEditUserDialogComponent } from './dialogs/review-edit-user-dialog/review-edit-user-dialog.component';
import { SelectClinicsDialogComponent } from './dialogs/select-clinics-dialog/select-clinics-dialog.component';
import { ShopManagerModule } from 'src/shop-manager/shop-manager.module';
import { ResetUserPasswordDialogComponent } from './dialogs/reset-user-password-dialog/reset-user-password-dialog.component';
import { PatientManagerModule } from 'src/patient-manager/patient-manager.module';
import { CommonPanelModule } from 'src/common-panel/common-panel.module';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return msalInterceptorConfig;
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return msalGuardConfig;
}

@NgModule({
  declarations: [
    AppComponent,
    AppWrapperComponent,
    NavbarComponent,
    HomeComponent,
    AvatarComponent,
    HomeTableComponent,
    CreateUserDialogComponent,
    EditUserDialogComponent,
    DeleteUserDialogComponent,
    ReviewEditUserDialogComponent,
    ReviewCreateUserDialogComponent,
    DialogContainerComponent,
    SelectClinicsDialogComponent,
    ResetUserPasswordDialogComponent,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MsalModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    ShopManagerModule,
    PatientManagerModule,
    CommonPanelModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
